module.exports = __webpack_public_path__ + "img/mt_logo.92662865.png";